import { Input, Provider, Org } from '../types';
import {
  musicReliefOrgLinks,
  fundraisingLinkValidationMsg,
  reliefOrgValidationMsg,
} from './constants';
import { unreachable } from '../lib/unreachable';

export function validate(
  link: Input,
  provider: Input<Provider>,
  org: Input<Org>,
) {
  link.validate([validateLinkForProviderAndOrg(provider, org)]);
}

// TODO also export slug regexps which will allow clean up in useInput
const cashappPrefix = 'https://cash.app/$';
const cashappRegex = /^https:\/\/cash\.app\/\$[a-zA-Z0-9_-]+$/;

const givealittlePrefix = 'https://givealittle.co.nz/';
const givealittleRegex = /^https:\/\/givealittle\.co\.nz\/(cause|org|fundraiser|project|event)\/[a-z0-9_-]+$/;

const paypalPrefix = 'https://www.paypal.me/';
const paypalRegex = /^https:\/\/www\.paypal\.me\/[a-zA-Z0-9_-]+$/;

const gofundmePrefix = 'https://www.gofundme.com/f/';
const gofundmeRegex = /^https:\/\/www\.gofundme\.com\/f\/[a-zA-Z0-9_-]+$/;

const mercadopagoPrefix = '';
const mercadopagoRegex = /(^https:\/\/www\.mercadopago\.((cl)|(com\.(br|cl|ar|pe|co|uy|mx)))\/[a-zA-Z0-9-_/?=#&]+$)|(^(http(s)?:\/\/mpago\.la\/[a-zA-Z0-9-_/?=#&]+$))/;

const payulatamPrefix = '';
const payulatamRegex = /^https:\/\/biz.payulatam.(com|cl)\/[L][0-9a-fA-F]{6,30}$/;

const payuturkeyPrefix = 'https://iyzi.link/';
const payuturkeyRegex = /^https:\/\/iyzi\.link\/[a-zA-Z0-9_-]+$/;

// export for test
export const providers: {
  [key in Provider]: { prefix: string; regex: RegExp } | null;
} = {
  cashapp: { prefix: cashappPrefix, regex: cashappRegex },
  givealittle: { prefix: givealittlePrefix, regex: givealittleRegex },
  gofundme: { prefix: gofundmePrefix, regex: gofundmeRegex },
  mercadopago: { prefix: mercadopagoPrefix, regex: mercadopagoRegex },
  musicrelieforg: null,
  paypal: { prefix: paypalPrefix, regex: paypalRegex },
  payu_latam: { prefix: payulatamPrefix, regex: payulatamRegex },
  payu_turkey: { prefix: payuturkeyPrefix, regex: payuturkeyRegex },
};

export function setPrefix(link: Input<string>, providerValue: Provider | '') {
  if (!providerValue) return;
  const providerPrefix = providers[providerValue]?.prefix;
  if (providerPrefix) {
    link.setPrefix(providerPrefix);
  }
}

export function validateLinkForProviderAndOrg(
  provider: Input<Provider>,
  org: Input<Org>,
) {
  return function validateLink(link?: string) {
    if (!provider) return 'Must select a provider';

    switch (provider.value) {
      case 'cashapp': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(cashappRegex) ? null : fundraisingLinkValidationMsg;
      }
      case 'givealittle': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(givealittleRegex)
          ? null
          : fundraisingLinkValidationMsg;
      }
      case 'gofundme': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(gofundmeRegex) ? null : fundraisingLinkValidationMsg;
      }
      case 'mercadopago': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(mercadopagoRegex)
          ? null
          : fundraisingLinkValidationMsg;
      }
      case 'musicrelieforg': {
        if (!org.value) return reliefOrgValidationMsg;
        return link === musicReliefOrgLinks[org.value]
          ? null
          : reliefOrgValidationMsg;
      }
      case 'paypal': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(paypalRegex) ? null : fundraisingLinkValidationMsg;
      }
      case 'payu_latam': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(payulatamRegex)
          ? null
          : fundraisingLinkValidationMsg;
      }
      case 'payu_turkey': {
        if (!link) return fundraisingLinkValidationMsg;
        return link?.match(payuturkeyRegex)
          ? null
          : fundraisingLinkValidationMsg;
      }
      case '':
        return 'Must select a provider';
      default:
        unreachable(provider.value);
        return 'Must select an org';
    }
  };
}
